import React, { useState } from "react";
import ShowAll from "./components/ShowAll/ShowAll";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const Team = (_props: CustomProps) => {
  const [tabValue] = useState<string>("Show All");

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      {tabValue === "Show All" ? <ShowAll type={"all"} /> : null}
    </div>
  );
};

export default Team;
